// extracted by mini-css-extract-plugin
export default {"Search":"ComponentsList_Search__UyYCc","Loading":"ComponentsList_Loading__FU7Uz"};